import z from 'zod'
import { valuesValidations } from './utils'

export const getUserConfirmDataSchema = (
  flagAddress: boolean,
  flagEmergencyContacts: boolean,
  flagPregnancy?: boolean,
  hasPregnancyData?: boolean,
) => {
  return z
    .object({
      email: z.string(),
      cellphone: z
        .string()
        .nonempty('Campo obrigatório')
        .trim()
        .refine(cellphone => {
          const parsedCellphone = cellphone?.replace(/[()-\s]/g, '')

          return parsedCellphone?.length === 11
        }, 'Celular inválido'),
      sex: z.string().nonempty('Campo obrigatório'),
      cep: z.string(),
      streetName: z.string(),
      number: z.string(),
      neighborhood: z.string(),
      complement: z.string(),
      city: z.string(),
      state: z.string(),
      emergencyContactFullName: z.string(),
      relationship: z.string(),
      emergencyContactCellphone: z.string(),
      weeksPregnancy: z?.string(),
      daysPregnancy: z?.string(),
      lastMenstrualPeriodDate: z.any(),
    })
    .superRefine((val, ctx) => {
      valuesValidations(
        val,
        ctx,
        flagAddress,
        flagEmergencyContacts,
        flagPregnancy,
        hasPregnancyData,
      )
    })
}

export const UserConfirmDataSchema = z
  .object({
    email: z.string(),
    cellphone: z
      .string()
      .nonempty('Campo obrigatório')
      .trim()
      .min(15, 'Celular inválido'),
    sex: z.string().nonempty('Campo obrigatório'),
    cep: z.string().nonempty('Campo obrigatório').min(9, 'CEP inválido'),
    streetName: z.string().nonempty('Campo obrigatório'),
    number: z.string().nonempty('Campo obrigatório'),
    neighborhood: z.string().nonempty('Campo obrigatório'),
    complement: z.string(),
    city: z.string().nonempty('Campo obrigatório'),
    state: z.string().nonempty('Campo obrigatório'),
    emergencyContactFullName: z.string().nonempty('Campo obrigatório'),
    relationship: z.string().nonempty('Campo obrigatório'),
    emergencyContactCellphone: z
      .string()
      .nonempty('Campo obrigatório')
      .trim()
      .min(14, 'Celular inválido'),
  })
  .superRefine((val, ctx) => {
    if (val.cellphone === val.emergencyContactCellphone) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message:
          'Os telefones do titular e do contato de emergência devem ser diferentes.',
        path: ['emergencyContactCellphone'],
      })
    }
  })
